let passport = {
    // 
    login(){
        // sit
        if (location.host.includes('localhost') || location.host.includes('bpm3-admin-sit-usa.platanus.com')) {
            return 'https://sso-sit-usa.platanus.com/public/login?requestUrl='
        }
        if (location.host.includes('bpm3-admin-usa.platanus.com')) {
            return 'https://sso-usa.platanus.com/public/login?requestUrl='
        }
        return 'https://sso-usa.platanus.com/public/login?requestUrl='
      },
    loginout(){
        if (location.host.includes('localhost') || location.host.includes('bpm3-admin-sit-usa.platanus.com')) {
            return 'https://sso-sit-usa.platanus.com/public/logout?loginType=mixLogin&jumpUrl='
        }
        if (location.host.includes('bpm3-admin-usa.platanus.com')) {
            return 'https://sso-usa.platanus.com/public/logout?loginType=mixLogin&jumpUrl='
        }
        return 'https://sso-usa.platanus.com/public/logout?loginType=mixLogin&jumpUrl='
    }
}

export default passport
// SIT环境	PC端	
// 内网

// 外网

// http://bpm3.longfor.sit:8088/

// https://bpm3sit.longfor.com:9553

// https://bpm3stest.longhu.net

// 手机端	
// 外网

// https://bpm3stest.longhu.net:8089/

// https://bpm3stest.longhu.net:9553/

// UAT环境	PC端	
// 内网

// 外网

// http://bpm3s.longfor.uat:8088/

// https://bpm3uat.longfor.com:9553

// https://bpm3suat.longhu.net

// 手机端	外网	
// https://bpm3suat.longhu.net:8089

// https://bpm3suat.longhu.net:9553

// 预生产环境	PC端	
// 内网

// 外网

// http://bpm3pre.longhu.net

// https://bpm3pre.longfor.com:9553

// https://bpm3pre.longhu.net

// 手机端	外网	
// https://bpm3pre.longhu.net:8099

// https://bpm3pre.longhu.net:9553

// 生产环境

// PC端	
// 内网

// 外网

// http://bpm3.longhu.net/

// https://bpm3.longfor.com:9553

// https://bpm3.longhu.net

// 手机端	外网	
// https://bpm3.longhu.net:8099/

// https://bpm3.longhu.net:9553/


// WEBPACK FOOTER //
// ./src/assets/js/passport.js